@if (store.totalCount() > 0) {

    <div class="preview-root" [class.expanded]="isExpanded()">

        <div class="card-list-scroll-area">
            @for (note of viewList(); track note.id) {
                <app-push-preview-card
                        [notification]="note"
                        [autoClose]="shouldAutoClose()"
                        [autoCloseTimeoutMs]="timeoutMs()"
                        (dismiss)="onDismiss($event)"
                        (clickNotification)="onNotificationClick($event)"
                ></app-push-preview-card>
            }
        </div>

        <div class="preview-controls">

            @if (!isExpanded()) {
                @if (hiddenCount() > 0) {
                    <button class="action-btn more-btn" (click)="onExpandClick()">
                        +{{ hiddenCount() }} more notification(s)
                    </button>
                }
                <button class="action-btn dismiss-all-btn" (click)="onDismissAll()">
                    Dismiss all
                </button>
            }

            @if (isExpanded()) {
                <div class="expanded-actions">
                    <button class="action-btn more-btn flex-fill" (click)="onCollapseClick()">Collapse</button>
                    <button class="action-btn dismiss-all-btn flex-fill" (click)="onDismissAll()">Dismiss all</button>
                </div>
            }
        </div>

    </div>
}